import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import VueI18n from 'vue-i18n'
import './utils/rem'

// 引入Element ui组件
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.use(VueI18n)

//引入svg组件
// import './utils/iconsSvg'
// import '@/svgIcon/index.js'
import './icons' // icon
// import animated from 'animate.css' // 

// Vue.use(animated)
// import wow from 'wowjs'
// Vue.prototype.$wow=wow

// 多语言
const i18n = new VueI18n({
  locale: window.localStorage.getItem('user_lang') == null ? "zh" : window.localStorage.getItem('user_lang'),    // 语言标识
  messages: {
    'zh': require('./lang/zh'),   // 中文语言包
    'en': require('./lang/en')    // 英文语言包
  },
})


// 百度地图
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'http://api.map.baidu.com/api?v=2.0&ak=j1UfUvVQdkiGpkDZjAuQyvbjkdaWH9KG'
})


// 引入字体图标
import './assets/font/iconfont.css'

// 引入全局样式表
import "./assets/css/global.css"

import api from "./api"; // 导入api接口
Vue.prototype.$api = api; // 将api挂载到vue的原型上



Vue.config.productionTip = false //阻止启动生产消息

router.beforeEach((to, from, next) => {
  // if (to.meta.title) {
  document.title = "沃时派客"
  // }
  next()
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

//挂载路由导航守卫
// router.beforeEach((to,from,next) => {
//   // to 即将要进入的目标 路由对象
//   // form 当前导航正要离开的路由
//   // next 一个函数，表示放行   两个使用方式 next()放行  next('/login')强制跳转
//   if(to.path === "/Login") return next()
//   // 获取token
//   const tokenStr = window.sessionStorage.getItem('token')
//   // console.log(tokenStr)
//   if(!tokenStr) return next('/login')
//   next()
// })